import React from "react"
import { withStyles } from "@material-ui/core/styles"
import styles from "./styles"
import classnames from "classnames"

const Sponsor = ({ sponsor, classes, hidden }) => (
  <div
    className={classnames(classes.imageContainer, {
      [classes.imageHidden]: hidden
    })}
  >
    {sponsor.image ?
      <img className={classes.image} src={sponsor.image_url} /> :
      <img className={classes.image} src={`https://res.cloudinary.com/bidr/image/upload/w_400,f_auto,q_auto,e_colorize,co_rgb:f1f1f1/w_0.9,c_scale,fl_relative,l_text:oswald_60:${encodeURIComponent(sponsor.sponsor_name)},g_center,co_rgb:333333/eventgives/img/white_logo.png`} />
    }
  </div>)


export default withStyles(styles, { withTheme: true })(Sponsor)



// WEBPACK FOOTER //
// ./src/components/Sponsor/index.jsx